module.exports = __webpack_public_path__ + "static/media/education-object-1-0-1.b756e690.svg";